import { useContext } from "react";

import { useSync } from "data/hub/sync";

import { fromGlobalId } from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const STEPS = {
  ReassignTasks: "reassign_tasks",
  ReplaceUser: "replace_user",
};

class AsyncStepsBuilder {
  #steps = [];

  get steps() {
    return this.#steps;
  }

  buildReassignTaskStep({ fromAssigner, toAssigner }) {
    if (!toAssigner || !fromAssigner) return this;

    this.#steps.push({
      name: STEPS.ReassignTasks,
      data: { toAssigner, fromAssigner },
    });

    return this;
  }

  buildReplaceUserStep({ fromAssigner, toAssigner, newUserInfo }) {
    if (!newUserInfo || Object.keys(newUserInfo).length === 0) return this;

    this.#steps.push({
      name: STEPS.ReplaceUser,
      data: {
        fromAssigner: fromAssigner,
        toAssigner: toAssigner,
        newUserInfo: {
          ...newUserInfo,
          userRole: newUserInfo.userRole
            ? fromGlobalId(newUserInfo.userRole)
            : undefined,
        },
      },
    });

    return this;
  }
}

const useAsyncSteps = () => {
  const { runAsyncJob, reloadData } = useSync();
  const { fireSuccess } = useContext(ToasterContext);

  return {
    trigger: ({
      newUserInfo,
      successMessage,
      onComplete = reloadData,
      ...params
    }) => {
      const { steps } = new AsyncStepsBuilder()
        .buildReplaceUserStep({ ...params, newUserInfo })
        .buildReassignTaskStep(params);

      if (steps.length > 0)
        runAsyncJob(steps, () => {
          onComplete();
          fireSuccess(successMessage);
        });
    },
  };
};

export default useAsyncSteps;
